import { render, staticRenderFns } from "./configuracion.vue?vue&type=template&id=963c93a0&scoped=true&"
import script from "./configuracion.vue?vue&type=script&lang=ts&"
export * from "./configuracion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963c93a0",
  null
  
)

export default component.exports